export default "__VITE_ASSET__a61ddb94__"